import { render, staticRenderFns } from "./PrintableInvoice.vue?vue&type=template&id=4ce68990&"
import script from "./PrintableInvoice.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PrintableInvoice.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports